
export enum DirectSaleDetailSnapshotWsEventResponseDtoEvent {
  DirectSaleDetailSnapshot= 'DirectSaleDetailSnapshot',

}